import { FormSchemaKey } from '@/enums'
import { message } from 'ant-design-vue'
import { DownloadBase } from '@/config'
import { keys, pickBy, cloneDeep, each, map, isArray } from 'lodash';
import type { TablePaginationConfig } from 'ant-design-vue'
import { newsCondition } from '@/views/content-management/news-management/newTypes';
import dayjs from 'dayjs'
import { i18nt } from '@/i18n';

export const setArrayItemValue = (
  arr: FormSchema[],
  objkey: string,
  // valKey: FormSchemaKey,
  valKey: string,
  // value: never[] & Option[] & Rule[] & TreeOption[] & boolean
  value: any
) => {
  arr.forEach((item: FormSchema) => { if (item['key'] === objkey) item[valKey] = value });
}

/**
 * 递归给树选择组件返回所需数据格式
 * @param {*} treeSelectData 后台返回的树选择数据
 */
export const normalizeTreeSelectData = (treeSelectData: TreeOption[]) => {
  (treeSelectData || []).forEach(item => {
    item.title = item.name;
    item.value = item.id;
    item.key = item.id;
    item.children && item.children.length > 0 && normalizeTreeSelectData(item.children);
  });
  return treeSelectData;
};
//将对象转为formData格式
export const paramsToFormData = (obj) => {
  const formData = new FormData();
  Object.keys(obj).forEach((key) => {
    if (obj[key]) {
      if (obj[key] instanceof Array) {
        obj[key].forEach((item) => {
          formData.append(key, item);
        });
        return;
      }
      formData.append(key, obj[key]);
    }
  });
  return formData;
}

export const postDownLoad = (downloadUrl, params = {}, isForm = false) => {
  let paramsObj = {
    method: 'POST',
    credentials: 'include',
  }
  if (isForm) {
    paramsObj.body = params
  } else {
    paramsObj.body = window.JSON.stringify(params)
    paramsObj.headers = new Headers({
      'Content-Type': 'application/json'
    })
  }
  fetch(downloadUrl, paramsObj)
    .then((response: any) => {
      console.log('response', response)
      response.blob().then(blob => {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        const fileName = response.headers
          .get('Content-Disposition') && response.headers
            .get('Content-Disposition')
            .split('=')[1]
        if (fileName) {
          a.download = decodeURIComponent(fileName)
          a.click()
          message.success('success')
        } else {
          message.error('failed')
        }
      })
    })
    .catch(error => {
      message.error('failed')
    })
}
//计算滚动高度
export const calcScrollY = () => {
  //搜索表单高度、面包屑高度、 64 、Tab栏高度、自定义去掉的高度
  let scrollHeight
  let formHeight = document.querySelectorAll('.basic-form')[0].clientHeight
  const tabHeight = document.querySelectorAll('.ant-tabs-nav') && document.querySelectorAll('.ant-tabs-nav').length ? document.querySelectorAll('.ant-tabs-nav')[0].clientHeight : 0
  const plusHeight = formHeight + 64 + 250 + tabHeight
  const bodyHeight = document.body.clientHeight
  if (bodyHeight - plusHeight > 120) {
    scrollHeight = bodyHeight - plusHeight
  } else {
    scrollHeight = 120
  }
  console.log('formHeight', scrollHeight, plusHeight, document.body.clientHeight)
  return scrollHeight
}


// 主工程通信
export const sendMessage = (message: unknown) => {
  window.parent.postMessage(JSON.stringify(message), '/')
}

// 对象集合转Map 
export const objectArr2Map = (array, key, value) => {
  const mapData = {}
  array.forEach(item => { mapData[item[key]] = item[value] });
  return mapData
}

/**
 * 递归给树组件只可选择层级
 * @param {*} treeSelectData 后台返回的树选择数据
 * 多选时需要勾选bu/subbu
 */
export const treeSelectDataMultipleDisable = (treeSelectData: TreeOption[], layer: number, countryIdArray: []) => {
  (treeSelectData || []).forEach(item => {
    // subbu层级且该subbu下没有国家时禁用此选项
    item.disabled = item.layer === 2 && item.subList.length === 0
    item.subList && item.subList.length > 0 && treeSelectDataMultipleDisable(item.subList, layer, countryIdArray);
  });
  return treeSelectData;
};
// 下载
export const handleDownload = (url) => {
  let downloadUrl
    ;
  const TestEnv = /http:[/][/]localhost:8009/g.test(window.location.origin) || /https:[/][/]portal-test-admin.hikvision.com/g.test(window.location.origin);
  const DevEnv = /https:[/][/]portal-dev-admin.hikvision.com/g.test(window.location.origin);
  const UatEnv = /https:[/][/]epadmin-uat.hikvision.com/g.test(window.location.origin);

  if (TestEnv) {
    downloadUrl = '/INTELb2bTest/'
  } else if (DevEnv) {
    downloadUrl = '/INTELb2bTest/'
  } else if (UatEnv) {
    downloadUrl = '/INTELb2bUat/'
  } else {
    downloadUrl = '/INTELb2bPro/'
  }

  window.open(`${DownloadBase}${downloadUrl}${url}`)
  // /http:[/][/]localhost:8009/g.test(window.location.origin) ||
  //   /https:[/][/]portal-test-admin.hikvision.com/g.test(window.location.origin)
  //   ? (downloadUrl = '/INTELb2bTest/')
  //   : /https:[/][/]epadmin-uat.hikvision.com/g.test(window.location.origin)
  //     ? (downloadUrl = '/INTELb2bUat/')
  //     : (downloadUrl = '/INTELb2bPro/')
  // window.open(`${DownloadBase}${downloadUrl}${url}`)
}

// 没有多选框，bu/subbu不能勾选
export const treeSelectDataDisable = (treeSelectData: TreeOption[], layer: number, countryIdArray: []) => {
  (treeSelectData || []).forEach(item => {
    item.disabled = item.layer < layer
    if (item.layer === 3) item.disabled = countryIdArray.includes(item.id)
    item.subList && item.subList.length > 0 && treeSelectDataDisable(item.subList, layer, countryIdArray);
  });
  return treeSelectData;
};


// 判断数据类型的方法（对typeof的增强）
export function valueType(obj) {
  if (obj === null) {
    return 'null';
  }
  if (typeof Array.isArray === 'function') {
    // 浏览器支持则使用isArray()方法
    if (Array.isArray(obj)) {
      return 'array';
    }
  } else if (Object.prototype.toString.call(obj) === '[object Array]') {
    // 否则使用toString方法
    return 'array';
  }
  return typeof obj;
}

/**
 * @description 去空格
 * @param str string 字符串
 * @return str string 新的字符串
 */
export function trim(str) {
  return str.replace(/(^\s*)|(\s*$)/g, '');
}

/**
 * @description 删除字段为空属性
 * @param obj object 需要删除空属性的对象
 * @return object 返回新的对象
 */
export function deleteObjNull(obj) {
  if (!obj) return null;
  if (valueType(obj) !== 'array' && valueType(obj) !== 'object') {
    return obj;
  }
  // 去前后空格
  let _obj = { ...obj };
  keys({ ...obj }).map(item => {
    _obj[item] =
      valueType(obj[item]) === 'string'
        ? trim(obj[item])
        : valueType(obj[item]) === 'object'
          ? deleteObjNull(obj[item])
          : valueType(obj[item]) === 'array'
            ? obj[item].map(_item => deleteObjNull(_item))
            : obj[item];
  });
  return pickBy(_obj, n => {
    if (valueType(n) === 'object') {
      return Object.keys(n).length > 0;
    }
    return n !== '' && n !== -1 && n !== '-1' && n !== null && n !== undefined;
  });
}

/**

* 得到字符串的字符长度（一个汉字占两个字符长）

*/

export const getBytesLength = (str: string): number => {
  return str.replace(/[\u4e00-\u9fa5]/g, 'xxx').length;
}

// 保存搜索参数
export const saveSearchData = (pagination: TablePaginationConfig, formSource: newsCondition, activeKey: string) => {
  sessionStorage.setItem("pagination", JSON.stringify(pagination));
  sessionStorage.setItem("formSource", JSON.stringify(formSource));
  sessionStorage.setItem("activeKey", JSON.stringify(activeKey));
}

//获取给定时间的开始时间凌晨0:00:00 和 结束时间11:59:59
export const useTimePeriod = (startDate: number, endDate: number): Record<string, number> => {
  const startTime = new Date(new Date(startDate).toLocaleDateString()).getTime()
  const endTime = new Date(new Date(endDate).setHours(23, 59, 59, 999)).getTime()
  return {
    startTime,
    endTime
  }
}

/**
 * 将后台返回的数据标准化，以满足Tree组件的数据结构
 * @param {Array} searchTreeData 后台返回的treeData(一维数组)
 */
export function normalizeTreeData(searchTreeData: Array<any>) {
  let treeData: Array<object> = [];//多维数组(树结构数据)
  let flatData: Array<object> = [];//一维数组(扁平化数据)

  if (!Array.isArray(searchTreeData)) {
    return { treeData, flatData }
  }


  searchTreeData.forEach((item, index) => {
    item.title = item.typeName;
    if (item.parentId === 0 && !item.goodsLevel) {
      // 一级分类
      item.key = item.productTypeId + '-1'
    }
    if (item.parentId !== 0 && !item.goodsLevel) {
      // 二级分类
      item.key = item.productTypeId + '-2'
    }
    if (item.parentId !== 0 && item.goodsLevel) {
      // 三级分类
      item.key = item.productTypeId + '-3'
    }
  })
  flatData = searchTreeData;

  // 为树形结构添加一级节点
  flatData.forEach((item) => {
    if (item.parentId === 0) {
      treeData.push(item);
    }
  })

  /**
  * 为父节点添加对应的子节点
  * @param {Array} parentNode 父节点
  */
  const generateChildNode = (parentNode) => {
    parentNode.forEach((parentItem) => {
      if (!parentItem.goodsLevel && flatData.some(childItem => childItem.parentId === parentItem.productTypeId)) {
        parentItem.children = [];
        const childNode = flatData.filter(_childItem => _childItem.parentId === parentItem.productTypeId);
        parentItem.children.push(...childNode);
        generateChildNode(childNode);
      }
    })
  }
  generateChildNode(treeData);
  return { treeData, flatData };
}

// 获取节点信息
export const produceTreeKeys = (key: string, treeData: Array<Record<string, any>>) => {
  if (!key || !Array.isArray(treeData)) return {}

  const newTreeData = cloneDeep(treeData);
  let nodeKey = key.split('-')[0]; //点击的节点id
  let level = key.split('-')[1]; // 点击的树层级
  let goodsIdList: Array<Record<string, any>> = [],
    productSupTypeId,
    productTypeId;

  newTreeData.forEach(firstItem => {
    if (level === '1') {
      //一级节点
      if (firstItem.productTypeId == nodeKey) {
        productSupTypeId = firstItem.productTypeId;
      }
    }
    if (level === '2') {
      firstItem.children &&
        firstItem.children.forEach(secondItem => {
          //二级节点
          if (secondItem.productTypeId == nodeKey) {
            productSupTypeId = firstItem.productTypeId;
            productTypeId = secondItem.productTypeId;
          }
        });
    }
    if (level === '3') {
      firstItem.children &&
        firstItem.children.forEach(secondItem => {
          secondItem.children &&
            secondItem.children.forEach(thirdItem => {
              //三级节点
              if (thirdItem.productTypeId == nodeKey) {
                productSupTypeId = firstItem.productTypeId;
                productTypeId = secondItem.productTypeId;
                goodsIdList.push(thirdItem.productTypeId);
              }
            });
        });
    }
  });

  return { goodsIdList, productSupTypeId, productTypeId }
}

export const setSearchParams = (params: Record<string, any>, currentRouteName: string): void => {
  const searchParams = window.localStorage.getItem('ep2-search-params');
  if (searchParams) {
    const JSONParams = JSON.parse(searchParams);
    JSONParams[currentRouteName] = params;
    window.localStorage.setItem('ep2-search-params', JSON.stringify(JSONParams));
  } else {
    const sessionParams: Record<string, any> = {};
    sessionParams[currentRouteName] = params;
    window.localStorage.setItem('ep2-search-params', JSON.stringify(sessionParams));
  }
};

// 寻找数组中特定id的值
export const findNodeById = (arr, targetId) => {
  for (let obj of arr) {
    if (obj.id === targetId) {
      return obj
    }

    // 检查嵌套的子列表
    if (obj.subList && Array.isArray(obj.subList)) {
      const nestedResult = findNodeById(obj.subList, targetId);
      if (nestedResult) {
        return nestedResult;
      }
    }
  }

  // 如果没有找到，则返回null或undefined
  return null;
}


// 时间转秒数
export const timeToSeconds = (timeStr) => {
  const parsedTime = dayjs(timeStr, 'HH:mm:ss');
  const hours = parsedTime.hour();
  const minutes = parsedTime.minute();
  const seconds = parsedTime.second();
  return hours * 3600 + minutes * 60 + seconds;
}
/**
 * 递归给树选择组件返回所需数据格式 --- 只能选择最低层级
 * @param {*} treeSelectData 后台返回的树选择数据
 */
export const treeSelectDataSelectLow = (treeSelectData: TreeOption[]) => {
  (treeSelectData || []).forEach(item => {
    if (item.children && item.children.length > 0) {
      item.disabled = true
      treeSelectDataSelectLow(item.children);
    }
  });
  return treeSelectData;
};

// 秒转时间
export function secondsToHHMMSS(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds - (hours * 3600)) / 60);
  const remainingSeconds = seconds - (hours * 3600) - (minutes * 60);

  return dayjs().startOf('day').add(hours, 'hour').add(minutes, 'minute').add(remainingSeconds, 'second');
}
// 处理并返回已修改的富文本字符串
export function processString(originalString: string) {
  let modifiedString = originalString
  // 检查"<table"是否存在且它前面没有"<div style="max-width: 100%; overflow-x: auto">"
  if (
    originalString.includes('<table') &&
    !/<div class="scroll-table" style="max-width: 100%; overflow-x: auto">(<table)/.test(originalString)
  ) {
    // 在"<table"前插入"<div style="max-width: 100%; overflow-x: auto">"
    modifiedString = originalString.replace(
      /(<table)/,
      '<div class="scroll-table" style="max-width: 100%; overflow-x: auto">$1'
    )
  }
  // 检查"</table>"是否存在且其后面没有"</div>"
  if (modifiedString.includes("</table>") && !/<\/table>(<\/div>|$)/.test(modifiedString)) {
    // 在"</table>"后插入"</div>"
    modifiedString = modifiedString.replace(/<\/table>/, '</table></div>');
  }
  return modifiedString
}
export const formatDateFromSpecialType = day => {
  return (day && dayjs(day).format('DD/MMM/YYYY')) || ''
}

export const formatTimeFromSpecialType = day => {
  return (day && dayjs(day).format('HH:mm')) || ''
}

export const multipleFormatTimeFromSpecialType = day => {
  return (day && dayjs(day).format('MMM,DD HH:mm')) || ''
}

// 平铺数组
export const flattenTree = (data, result = [],) => {
  each(data, (item) => {
    // 将当前节点添加到结果数组，可以根据需要调整要提取的属性
    result.push(item);

    // 如果当前项有子节点，则递归调用flattenTree
    if (item.subList) {
      flattenTree(item.subList, result); // 传递当前节点的id作为父节点标识
    }
  });

  return result;
}

export const disNonChild = (array) => {
  array.forEach(item => {
    if (item.children && item.children.length) {
      item.disabled = true;
      disNonChild(item.children);
    } else {
      item.disabled = false;
    }
  });
  return array;
}

export function getBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export const transformMenuData = (menuData) => {
  return map(menuData, (menu) => {
    const transformedMenu = {
      title: i18nt(menu.mName),
      key: menu.permissionId || menu.menuId,
      checkable: false,
      children: [],
    };

    if (isArray(menu.childMenuDTOList) && menu.childMenuDTOList.length > 0) {
      transformedMenu.children = map(menu.childMenuDTOList, (childMenu) => {
        const transformedChildMenu = {
          title: i18nt(childMenu.mName),
          key: childMenu.permissionId || menu.menuId,
          children: [],
        };

        if (isArray(childMenu.buttonDTOList) && childMenu.buttonDTOList.length > 0) {
          transformedChildMenu.children = map(childMenu.buttonDTOList, (button) => ({
            title: i18nt(button.buttonName),
            key: button.permissionId,
          }));
        }

        return transformedChildMenu;
      });
    }

    return transformedMenu;
  });
}

export function dataURLtoFile(dataURL, filename) {
  const arr = dataURL.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

// 根据id查找对应的国家信息
export function breadthQuery(tree: any, id: number) {
  let stark = [];
  stark = stark.concat(tree);
  while (stark.length) {
    let temp = stark.shift();
    if (temp.subList) {
      stark = stark.concat(temp.subList);
    }
    if (temp.id === id) {
      return temp;
    }
  }
}
export function openIframeUrl(url: string) {
  sessionStorage.removeItem('routerName');
  sessionStorage.removeItem('routerQuery');
  sessionStorage.removeItem('beforeunload');
  window.open(url)
}

// 文件流下载
export function fileDownLoad(url: string, type = 'post') {
  let method = type == 'post' ? 'POST' : 'GET'
  let paramsObj = {
    method,
    credentials: 'include',
  }
  fetch(url, paramsObj)
    .then((response: any) => {
      console.log('response', response)
      response.blob().then(blob => {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        const fileName = response.headers
          .get('Content-Disposition') && response.headers
            .get('Content-Disposition')
            .split('=')[1]
        if (fileName) {
          a.download = decodeURIComponent(fileName)
          a.click()
          message.success('success')
        } else {
          message.error('failed')
        }
      })
    })
    .catch(error => {
      message.error('failed')
    })
}

export function findIdInLayer3(data, targetId) {
  // 如果当前节点是目标层级且 ID 匹配，返回 true
  if (data.layer === 3 && data.id === targetId) {
    return true;
  }

  // 如果当前节点有子节点，递归查找子节点
  if (data.children && data.children.length > 0) {
    for (let child of data.children) {
      if (findIdInLayer3(child, targetId)) {
        return true; // 如果在子节点中找到，返回 true
      }
    }
  }

  // 如果当前节点不符合条件且子节点中也没有找到，返回 false
  return false;
}

/**
 * 规范化对象中字符串属性的空格
 * @param obj 要处理的对象
 * @returns 处理后的新对象，所有字符串属性的头尾空格已去除，中间连续空格合并为一个
 */
export function normalizeObjectSpaces<T extends Record<string, any>>(obj: T): T {
  const normalized: Record<string, any> = {};

  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      // 处理字符串类型的属性
      normalized[key] = (obj[key] as string).trim().replace(/\s+/g, ' ');
    } else {
      // 非字符串属性保持原样
      normalized[key] = obj[key];
    }
  }

  return normalized as T;
}
export const dowloadFile = (options: { blob?: Blob, url?: string }, filename: string) => {

  let url = options.url
  if (options.blob) {
    url = window.URL.createObjectURL(options.blob)
  }
  if (url) {
    let a = document.createElement('a')
    a.href = url
    a.download = filename

    a.click()
    a.remove()
  } else {
    console.error('url is undefined');

  }

}
//提取中文和特殊字符
export function extractChineseAndSpecialChars(str: string): string {
  const regex = /[^\w\s]|[\u4e00-\u9fff]/g;
  const matches = str.match(regex);
  return matches ? matches.join('') : '';
}
// 计算中文和英文长度
export function chinesLangRule(maxLang: number, chN: number = 4) {
  return {
    validator: async (_rule: Rule, value: string | number) => {
      if (!value) return Promise.resolve()
      value = value.toString().trim()
      const cn = extractChineseAndSpecialChars(value).length
      const en = value.length - cn
      const lang = cn * chN + en
      if (lang > maxLang) {
        return Promise.reject(i18nt('ep_admin_explore_maxLen'))
      }
    }
  }
}

/**
 * 校验"数字*数字"格式的规则
 */
export function resolutionRule() {
  return {
    validator: async (_rule: Rule, value: string | number) => {
      if (!value) return Promise.resolve()
      value = value.toString().trim()
      // 匹配 "数字*数字" 格式，例如 "1920*1080" 或 "1920.5*1080.2"
      const regex = /^\d*\.?\d+\*\d*\.?\d+$/
      if (!regex.test(value)) {
        return Promise.reject('Must be "number*number"')
      }
      return Promise.resolve()
    }
  }
}
